import { useOverrides } from '../../store';
import css from './stats.module.scss';

interface Props {
    total: number;
}
export function Stats({ total }: Props) {
    const overrides = useOverrides(s => s.overrides);
    const intl = new Intl.NumberFormat('en-US', { minimumIntegerDigits: 2 });

    return (
        <div className={css.row}>
            <div className={css.group}>
                <p>Total</p>
                <span className={css.total}>{intl.format(total)}</span>
            </div>
            <div className={css.group}>
                <p>Overrides</p>
                <span className={css.overrides}>{Object.keys(overrides).length}</span>
            </div>
        </div>
    );
}
